import { useState, useEffect } from "react";
import axios from "axios";

export const useDisclaimers = () => {
  const [disclaimers, setDisclaimers] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDisclaimers = async () => {
      setLoading(true);
      try {
        const url = `${process.env.GATSBY_CMSV2_URL}/disclaimers`;
        const response = await axios.get(url);
        setDisclaimers(response.data || []);
      } catch (err) {
        console.error("Error getting disclaimers:", err);
        setError("Error loading disclaimers");
      } finally {
        setLoading(false);
      }
    };

    fetchDisclaimers();
  }, []); 

  // disclaimers is an array of objects that contain the following properties:
  // {
  //   name: "name of the disclaimer",
  //   enabled: true/false,
  //   forWeb: true/false,
  //   forMobile: true/false,
  //   `text_${en}`: "html english paragraph",
  //   `text_${es}`: "html spanish paragraph",
  // }
  return { disclaimers, loading, error };
};
